import React, { Component } from 'react';
import Modal from 'react-bootstrap/Modal';
import FaqContent from 'containers/FaqContent';
import './FaqModal.css';

class FaqModal extends Component {
  render() {
    const { onHide, ...otherProps } = this.props;

    return (
      <Modal dialogClassName="faq-modal" onHide={onHide} {...otherProps}>
        <Modal.Body>
          <FaqContent />
        </Modal.Body>
        <Modal.Footer>
          <button onClick={onHide} type="button" className="btn btn-success">
            Close
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default FaqModal;
